import { render, staticRenderFns } from "./VjsfBirthDate.vue?vue&type=template&id=257f82ba&scoped=true&"
import script from "./VjsfBirthDate.vue?vue&type=script&lang=js&"
export * from "./VjsfBirthDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257f82ba",
  null
  
)

export default component.exports